import React from 'react'
import BlurredText from "../../../../components/BlurredText";
import {Tooltip} from '@mui/material'

const RatingSegmentation = (props) => {
    const { ratingName, rating, count, lcBreakdown } = props
    const studentsWord = "תלמידים"

    const getLcTooltipContent = () => {
        if (!lcBreakdown) return ""
        const rows = Object.entries(lcBreakdown).filter(([, counts]) => {
            const ratingCount = counts[ratingName]
            return ratingCount > 0
        })
        if (!rows.length) return "אין תלמידים במרכזי למידה"
        return (
            <div style={{ direction: 'rtl', padding: '4px 0', minWidth: 120 }}>
                <div style={{ fontWeight: 'bold', marginBottom: 4 }}>מרכזי למידה:</div>
                {rows.map(([lcName, counts]) =>
                    <div key={lcName}>{lcName}: {counts[ratingName]} {studentsWord}</div>
                )}
            </div>
        )
    }

    return (
        !rating ||
        <Tooltip title={getLcTooltipContent()} placement="top" arrow>
            <div className={`bar-line-item ${ratingName}`}>
                <span className='percent'>
                    {rating.toFixed()}%
                    {count != null && <span className='count'> (
                        {<BlurredText>{count} </BlurredText>}
                        תלמידים)</span>}
                </span>
            </div>
        </Tooltip>
    )

}

export default RatingSegmentation